import Search from './Search';

export { Search };
export default Search;
